<template>
  <div class="col-grid-2">
    <div>
      <!-- TODO: turn this back on with en support -->
        <!-- <div class="lcu-form-fieldWrap">
            <label class="lcu-section-label" for="language">
                Preferencia de Idioma
                <button
                    type="button"
                    aria-label="edit language preference"
                    @click.prevent="toggleEdit('language')"
                    :class="{
                        'lcu-cancel-btn': edit.language
                    }"
                    class="lcu-edit-btn" />
            </label>
            <span v-if="!edit.language">
              {{ languageTitles[values.language] }}
            </span>
            <div class="lcu-input-grid" v-if="edit.language">
                <form-field :id="'language'" :label="''" :select="true">
                  <select
                    id="language"
                    name="language"
                    v-model="values.language"
                    @change.prevent="''"
                    class="lcu-form-select">
                    <option
                      v-for="language in ['en', 'es']"
                      :value="language"
                      :key="language">
                        {{ languageTitles[language] }}
                    </option>
                  </select>
                </form-field>
                <button-cta
                    :text="SAVE_TEXT"
                    :loading="loaders.language"
                    @on-click="onSave('language')" />
            </div>
        </div> -->
        <div class="lcu-form-fieldWrap">
            <label class="lcu-section-label" for="timeZone">
                Hora Local
                <button
                    type="button"
                    aria-label="edit time zone"
                    @click.prevent="toggleEdit('timeZone')"
                    :class="{
                        'lcu-cancel-btn': edit.timeZone
                    }"
                    class="lcu-edit-btn" />
            </label>
            <span v-if="!edit.timeZone">{{ values.timeZone }}</span>
            <div class="lcu-input-grid" v-if="edit.timeZone">
                <form-field :id="'timeZone'" :label="''" :select="true">
                  <select
                    id="timeZone"
                    name="timeZone"
                    v-model="values.timeZone"
                    @change.prevent="''"
                    class="lcu-form-select">
                    <option :value="zone" v-for="zone in zoneOptions" :key="zone">
                        {{ zone }}
                    </option>
                  </select>
                </form-field>
                <button-cta
                    :text="SAVE_TEXT"
                    :loading="loaders.timeZone"
                    @on-click="onSave('timeZone')" />
            </div>
        </div>
    </div>
    <div />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Country } from 'country-state-city';
import FormField from 'ç/forms/inputs/Field.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import moment from 'moment-timezone';
import { NOTIFICATION_SUCCESS, NOTIFICATION_ERROR, SAVE_TEXT } from '@/globals/constants';

export default {
  name: 'preferences-page',
  computed: {
    ...mapGetters(['user']),
    languageTitles() {
      return {
        en: 'English',
        es: 'Spanish',
      };
    },
  },
  components: {
    FormField,
    ButtonCta,
  },
  data() {
    return {
      zoneOptions: [],
      SAVE_TEXT,
      edit: {
        language: false,
        timeZone: false,
      },
      values: {
        language: '',
        timeZone: '',
      },
      initials: {
        language: '',
        timeZone: '',
      },
      loaders: {
        language: false,
        timeZone: false,
      },
    };
  },
  created() {
    this.setValues();
    const countries = Country.getAllCountries();
    const { isoCode } = countries.find(c => c.name === this.user.country);
    const countryZones = moment.tz.zonesForCountry(isoCode);
    this.zoneOptions = countryZones;
  },
  methods: {
    setValues() {
      this.values.language = this.user?.language || 'es';
      this.values.timeZone = this.user?.timeZone || this._timeZone;
    },
    async onSave(item) {
      if (this.loaders[item]) {
        return;
      }
      this.loaders[item] = true;
      try {
        this.initials[item] = this.values[item];
        await this.$students({
          method: 'updateUser',
          payload: {
            updates: {
              [item]: this.values[item],
            },
          },
        });
        this.$store.dispatch('setGlobalValue', {
          item: this.user,
          key: item,
          value: this.values[item],
        });
        this.edit[item] = false;
        this.$notify({
          title: NOTIFICATION_SUCCESS,
          text: 'Preferencia actualizada correctamente',
          type: 'success',
        });
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        this.$notify({
          title: NOTIFICATION_ERROR,
          text: message,
          type: 'error',
          duration: -1,
        });
      } finally {
        this.loaders[item] = false;
      }
    },
    toggleEdit(item) {
    // if editing but user hits cancel, reset to initial value & vice versa
      if (this.edit[item]) {
        this.values[item] = this.initials[item];
      } else {
        this.initials[item] = this.values[item];
      }
      this.edit[item] = !this.edit[item];
    },
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-input-grid {
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-column-gap: 10px;
}
</style>
